import { FC } from 'react'
import BaseRiseColor from '@/components/BaseRiseColor'
import { formatAddString } from '@/utils/tools'
import { MarketCoinStyled, CoinNameLabelStyled, CoinChangeNameStyled } from './style'

interface MarketProps {
  coinName?: string
  change?: number // 小数
}

/**
 * @description: 涨幅百分比
 * @param {*} param1
 * @return {*}
 */
const Market: FC<MarketProps> = ({ coinName, change }) => {
  const onClickHandle = () => {
    const tradeUrl = `/trade/${coinName?.toUpperCase()}_USDT`
    window.open(tradeUrl, '_blank')
  }

  return (
    <>
      {/* change 为0的情况需处理 */}
      {coinName || change?.toString() ? (
        <MarketCoinStyled onClick={onClickHandle}>
          <CoinNameLabelStyled>{coinName || '--'}</CoinNameLabelStyled>

          {change?.toString() ? (
            <BaseRiseColor value={change}>
              <CoinChangeNameStyled>{formatAddString(change)}</CoinChangeNameStyled>
            </BaseRiseColor>
          ) : null}
        </MarketCoinStyled>
      ) : null}
    </>
  )
}

export default Market
